import React, { FC } from 'react';
import { Button, Empty, Modal } from 'antd';
import { ComplianceChecklistReview } from './ComplianceChecklistReview';
import { ComplianceRequest } from '../../types/ComplianceTypes';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

interface ComplianceChecklistModalProps {
	visible: boolean;
	// The request whose stored checklistExtraction is shown. Read straight off the
	// request — the extraction is persisted with it, so there is nothing to fetch.
	complianceRequest: ComplianceRequest;
	onCancel: () => void;
}

// Read-only view of the checklist that was extracted from a request's sample
// document when the request was created. Same rendering the create wizard's
// review step uses.
export const ComplianceChecklistModal: FC<ComplianceChecklistModalProps> = ({
	visible,
	complianceRequest,
	onCancel,
}): React.ReactElement => {
	const extraction = nullSafeGet('checklistExtraction', complianceRequest);
	const hasItems = nullSafeGetOrElse('items.length', extraction, 0) > 0;
	const footer = (
		<Button type="primary" onClick={onCancel}>
			DONE
		</Button>
	);
	return (
		<Modal
			visible={visible}
			title={`Checklist: ${nullSafeGetOrElse('name', complianceRequest, 'Compliance request')}`}
			onCancel={onCancel}
			footer={footer}
			width={900}
			bodyStyle={{ maxHeight: '60vh', overflowY: 'auto' }}
		>
			{hasItems ? (
				<ComplianceChecklistReview extraction={extraction} />
			) : (
				<Empty description="No checklist was read from this request's sample document." />
			)}
		</Modal>
	);
};
